import { titlebarColorTheme } from 'UIComponents/card/BuilderCardUtils';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getJustifyContent = icon => {
  const justifyValue = icon ? 'unset' : 'center';
  return css(["justify-content:", ";"], justifyValue);
};
const Wrapper = styled.div.withConfig({
  displayName: "PreviewHeader__Wrapper",
  componentId: "d1b0k7-0"
})(["align-items:center;color:", ";display:flex;padding:", ";position:relative;", ";", ";"], ({
  theme
}) => theme.color['text-core-default'], ({
  theme
}) => theme.space['100'], props => titlebarColorTheme(props.use), props => getJustifyContent(props.icon));
const IconWrapper = styled.span.withConfig({
  displayName: "PreviewHeader__IconWrapper",
  componentId: "d1b0k7-1"
})(["margin-left:", ";margin-right:", ";"], ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.space['100']);
const PreviewHeader = ({
  children,
  icon,
  use = 'heffalump'
}) => /*#__PURE__*/_jsxs(Wrapper, {
  icon: icon,
  use: use,
  children: [icon && /*#__PURE__*/_jsx(IconWrapper, {
    children: icon
  }), children]
});
export default PreviewHeader;